<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-if="!loadingFromApi">
                    <form @submit.prevent="validateSaveCustomer">
                        <div class="form-group">
                            <label for="customerCodeInput">
                                Customer Code
                            </label>
                            <div class="text-danger" v-if="customer.customerCode.hasError">
                                {{ customer.customerCode.errorMessage}}
                            </div>
                            <input type="text" placeholder="Customer Code" class="form-control" id="customerCodeInput" v-model="customer.customerCode.value" disabled>
                        </div>
                        <hr>
                        <h5>Primary Customer Admin User Details</h5>
                        <div class="form-group">
                            <label for="nameInput">
                                First Name
                            </label>
                            <div class="text-danger" v-if="customer.firstName.hasError">
                                {{ customer.firstName.errorMessage}}
                            </div>
                            <input type="text" class="form-control" id="nameInput" v-model="customer.firstName.value">
                        </div>
                        <div class="form-group">
                            <label for="lastNameInput">
                                Last Name
                            </label>
                            <div class="text-danger" v-if="customer.lastName.hasError">
                                {{customer.lastName.errorMessage}}
                            </div>
                            <input type="text" class="form-control" id="lastNameInput" v-model="customer.lastName.value">
                        </div>
                        <div class="form-group">
                            <label for="emailAddressInput">
                                Email Address
                            </label>
                            <div class="text-danger" v-if="customer.emailAddress.hasError">
                                {{customer.emailAddress.errorMessage}}
                            </div>
                            <input type="email" class="form-control" id="emailAddressInput" v-model="customer.emailAddress.value">
                        </div>

                        <div class="form-group form-check" v-if="isUpdate && customer.primaryUserId !== null">
                            <input class="form-check-input" type="checkbox" value="" id="resetPasswordCheckbox" v-model="resetPassword">
                            <label class="form-check-label" for="resetPasswordCheckbox">
                                Reset Password
                            </label>
                        </div>
                        <div class="text-danger" v-if="customer.password.hasError">
                            {{customer.password.errorMessage}}
                        </div>
                        <div id="accordion" class="mb-3" v-if="!isUpdate || resetPassword || customer.primaryUserId === null">
                            <div class="card mb-1">
                                <div class="card-header" id="passwordResetHeading">
                                    <h5 class="m-0">
                                        <a class="accordingHeader text-dark w-100 collapsed" data-toggle="collapse" href="#collapseOne" aria-expanded="true">
                                            User Password (Password will be auto generated)
                                        </a>
                                    </h5>
                                </div>

                                <div id="collapseOne" class="collapse" aria-labelledby="passwordResetHeading" data-parent="#accordion">
                                    <div class="card-body">
                                        <password-generator :regeneratePassword="regeneratePassword" @passwordGenerated="onPasswordGenerated"></password-generator>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--                    <div class="form-group">-->
                        <!--                        <label>-->
                        <!--                            Date Of Birth-->
                        <!--                        </label>-->
                        <!--                        <div class="text-danger" v-if="customer.dateOfBirth.hasError">-->
                        <!--                            {{customer.dateOfBirth.errorMessage}}-->
                        <!--                        </div>-->
                        <!--                        <date-picker :format="'DD/MM/YYYY'" :elementId="'dateOfBirthDatePicker'" :date="customer.dateOfBirth.value" :initialiseDate="initialiseDueDate"-->
                        <!--                                    @dateChange="onDateOfBirthSelect"></date-picker>-->
                        <!--                    </div>-->
                        <hr>
                        <div class="text-danger">
                            {{customer.customerCanPlaceOrdersErrorMessage}}
                        </div>
                        <div class="form-group form-check">
                            <input class="form-check-input" type="checkbox" value="" id="ordersCollectionCheckbox" v-model="customer.customerCanPlaceCollectionOrders">
                            <label class="form-check-label" for="ordersCollectionCheckbox">
                                Eligible To Place Collection Orders
                            </label>
                        </div>
                        <div class="form-group form-check">
                            <input class="form-check-input" type="checkbox" value="" id="ordersDeliveryCheckbox" v-model="customer.customerCanPlaceDeliveryOrders">
                            <label class="form-check-label" for="ordersDeliveryCheckbox">
                                Eligible To Place Delivery Orders
                            </label>
                        </div>
                        <div class="form-group form-check">
                            <input class="form-check-input" type="checkbox" value="" id="ordersExTankCheckbox" v-model="customer.customerCanPlaceExTankOrders">
                            <label class="form-check-label" for="ordersExTankCheckbox">
                                Eligible To Place Ex-Tank Orders
                            </label>
                        </div>
                        <label>
                            Eligible Product Types
                        </label>
                        <div class="text-danger" v-if="customer.productTypeIdsToLink.hasError">
                            {{customer.productTypeIdsToLink.errorMessage}}
                        </div>
                        <div class="form-group form-check" v-for="productType in productTypes">
                            <input class="form-check-input" type="checkbox" value="" :id="productType.name + '_' + productType.productTypeId" v-model="productType.selected">
                            <label class="form-check-label" :for="productType.name + '_' + productType.productTypeId">
                                {{productType.name}}
                            </label>
                        </div>
                        <div class="form-group">
                            <label for="paymentTypeSelect">
                                Payment Type
                            </label>
                            <div class="text-danger" v-if="customer.paymentTypeId.hasError">
                                {{customer.paymentTypeId.errorMessage}}
                            </div>
                            <bootstrap-select :selectOptions="paymentTypes" :selectedOption="customer.paymentTypeId.value" :elementId="'paymentTypeSelect'"
                                              :returnSelectedOptionText="true"
                                              @changeSelect="onPaymentTypeSelect"></bootstrap-select>
                        </div>
                        <div class="form-group" v-if="customer.paymentTypeId.value !== null && customer.paymentTypeId.value !== paymentType.CUF">
                            <label>
                                Credit Limit
                            </label>
                            <div class="text-danger" v-if="customer.creditLimit.hasError">
                                {{customer.creditLimit.errorMessage}}
                            </div>
                            <currency-input class="form-control" v-model="customer.creditLimit.value"
                                            :options="{ currency: 'ZAR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true, hideCurrencySymbolOnFocus: false, precision: precision }"></currency-input>
                        </div>

                        <div class="form-group" v-if="customer.paymentTypeId.value === paymentType.CUF">
                            <label>
                                Credit Limit
                            </label>
                            <currency-input class="form-control" v-model="customer.creditLimit.value"
                                            :disabled="true"
                                            :options="{ currency: 'ZAR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true, hideCurrencySymbolOnFocus: false, precision: precision }"></currency-input>
                        </div>

                        <div class="form-group" v-if="customer.paymentTypeId.value !== null && customer.paymentTypeId.value !== paymentType.CUF && (companyId !== null && companyId > 0)">
                            <label>
                                Current Balance
                            </label>
                            <currency-input class="form-control" v-model="currentBalance"
                                            :disabled="true"
                                            :options="{ currency: 'ZAR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true, hideCurrencySymbolOnFocus: false, precision: precision }"></currency-input>
                        </div>

<!--                        <div class="form-group" v-if="customer.paymentTypeId.value !== null && customer.paymentTypeId.value !== paymentType.CUF && (companyId !== null && companyId > 0)">-->
<!--                            <label>-->
<!--                                Amount Used-->
<!--                            </label>-->
<!--                            <currency-input class="form-control" v-model="amountOfCreditUsed"-->
<!--                                            :disabled="true"-->
<!--                                            :options="{ currency: 'ZAR', currencyDisplay: 'narrowSymbol', autoDecimalDigits: true, hideCurrencySymbolOnFocus: false, precision: precision }"></currency-input>-->
<!--                        </div>-->

                        <h5 class="mb-4 mt-4">Company Details</h5>
                        <div class="form-group">
                            <label for="registrationBusinessNameInput">
                                Registered Business Name
                            </label>
                            <div class="text-danger" v-if="customer.companyDetails.businessName.hasError">
                                {{customer.companyDetails.businessName.errorMessage}}
                            </div>
                            <input type="text" class="form-control" id="registrationBusinessNameInput" v-model="customer.companyDetails.businessName.value">
                        </div>
                        <div class="form-group">
                            <label for="businessTradingNameInput">
                                Business Trading Name
                            </label>
                            <div class="text-danger" v-if="customer.companyDetails.tradingName.hasError">
                                {{customer.companyDetails.tradingName.errorMessage}}
                            </div>
                            <input type="text" class="form-control" id="businessTradingNameInput" v-model="customer.companyDetails.tradingName.value">
                        </div>
                        <div class="form-group">
                            <label for="holdingCompanyInput">
                                Holding Company
                            </label>
                            <div class="text-danger" v-if="customer.companyDetails.holdingCompany.hasError">
                                {{customer.companyDetails.holdingCompany.errorMessage}}
                            </div>
                            <input type="text" class="form-control" id="holdingCompanyInput" v-model="customer.companyDetails.holdingCompany.value">
                        </div>
                        <div class="form-group">
                            <label for="registrationNumberInput">
                                Company Registration Number
                            </label>
                            <div class="text-danger" v-if="customer.companyDetails.registrationNumber.hasError">
                                {{customer.companyDetails.registrationNumber.errorMessage}}
                            </div>
                            <input type="text" class="form-control" id="registrationNumberInput" v-model="customer.companyDetails.registrationNumber.value">
                        </div>
<!--                        <div class="form-group">-->
<!--                            <label for="branchInput">-->
<!--                                Branch-->
<!--                            </label>-->
<!--                            <div class="text-danger" v-if="customer.companyDetails.branch.hasError">-->
<!--                                {{customer.companyDetails.branch.errorMessage}}-->
<!--                            </div>-->
<!--                            <input type="text" class="form-control" id="branchInput" v-model="customer.companyDetails.branch.value">-->
<!--                        </div>-->
<!--                        <div class="form-group">-->
<!--                            <label for="branchNumberInput">-->
<!--                                Branch Number-->
<!--                            </label>-->
<!--                            <div class="text-danger" v-if="customer.companyDetails.branchNumber.hasError">-->
<!--                                {{customer.companyDetails.branchNumber.errorMessage}}-->
<!--                            </div>-->
<!--                            <input type="text" class="form-control" id="branchNumberInput" v-model="customer.companyDetails.branchNumber.value">-->
<!--                        </div>-->
                        <div class="form-group">
                            <label for="telephoneNumberInput">
                                Company Telephone Number
                            </label>
                            <div class="text-danger" v-if="customer.companyDetails.telephoneNumber.hasError">
                                {{customer.companyDetails.telephoneNumber.errorMessage}}
                            </div>
                            <input type="text" class="form-control" id="telephoneNumberInput" v-maska data-maska="### ### ####" v-model="customer.companyDetails.telephoneNumber.value">
                        </div>
                        <div class="form-group" v-show="customer.customerCanPlaceCollectionOrders">
                            <label for="discountGroupSelect">
                                Customer Discount Group
                            </label>
                            <div class="text-danger" v-if="customer.companyDetails.discountGroupId.hasError">
                                {{customer.companyDetails.discountGroupId.errorMessage}}
                            </div>
                            <bootstrap-select :selectOptions="discountGroups" :selectedOption="customer.companyDetails.discountGroupId.value" :elementId="'discountGroupSelect'"
                                              :returnSelectedOptionText="true"
                                              @changeSelect="onDiscountGroupSelect"></bootstrap-select>
                        </div>
                        <div class="form-group" v-if="customer.customerCanPlaceExTankOrders">
                            <label>
                                Select Zones
                            </label>
                            <div class="text-danger">
                                {{linkZonesErrorMessage}}
                            </div>
                            <div class="table-responsive pt-4">
                                <table class="table table-hover mb-0">
                                    <thead>
                                    <tr>
                                        <th>Zone</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="(zone, index) in companyZonesLinkedAndUnlinkedToCompany" :key="index">
                                        <td>{{zone.zone}}</td>
                                        <td>
                                            <input type="checkbox" v-model="zone.isSelected" @change="onZoneSelect"/>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="text-danger" v-if="customer.salesRepsToLinkMessage.hasError">
                                {{customer.salesRepsToLinkMessage.errorMessage}}
                            </div>
                            <label for="salesRepSelect">
                                Sales Rep
                            </label>
                            <br>
                            <div class="text-danger" v-if="customer.companyDetails.salesRepId.hasError">
                                {{customer.companyDetails.salesRepId.errorMessage}}
                            </div>
                            <div class="float-right mb-4" >
                                <button class="btn btn-primary" @click.prevent="selectSalesRepForCustomer">
                                    Assign Sales Reps
                                </button>
                            </div>
                            <data-table :headings="salesRepsHeadings"
                                        :data="companySalesReps"
                                        :hasNoPaging="true"
                                        :stateChanged="false"
                                        :hasActions="true"
                                        :hasNoFilter="true"
                                        :hasCustomActionComponent="true">
                                <template #actionComponent="{ userId, isAssigned }">
                                    <button @click.prevent="unAssignSalesRep(userId)" class="btn btn-primary">Remove</button>
                                </template>
                            </data-table>
<!--                            <input type="text" class="form-control" id="salesRepSelect" readonly="readonly" @click="selectSalesRepForCustomer" v-model="customer.companyDetails.salesRepName.value"/>-->
                        </div>
                        <div class="form-group">
                            <label for="erpCustomerCodeInput">
                                ERP Customer Code
                            </label>
                            <div class="text-danger" v-if="customer.companyDetails.erpCustomerCode.hasError">
                                {{customer.companyDetails.erpCustomerCode.errorMessage}}
                            </div>
                            <input type="text" class="form-control" id="erpCustomerCodeInput" v-model="customer.companyDetails.erpCustomerCode.value">
                        </div>
                        <div class="form-group">
                            <label for="vatNumberInput">
                                Tax/VAT Number
                            </label>
                            <div class="text-danger" v-if="customer.companyDetails.vatNumber.hasError">
                                {{customer.companyDetails.vatNumber.errorMessage}}
                            </div>
                            <input type="text" class="form-control" id="vatNumberInput" v-model="customer.companyDetails.vatNumber.value">
                        </div>

                        <button class="btn btn-primary mr-2" :disabled="loading">Save</button>
                        <button class="btn btn-secondary" @click.prevent="onBackClick" :disabled="loading">Back</button>

                    </form>
                </div>
                <loading-spinner :showSpinner="loadingFromApi"></loading-spinner>
            </div>
        </div>
    </div>

    <error-modal :modalHeading="errorModal.modalHeading" 
                :elementId="errorModal.elementId" 
                :modalMessage="errorModal.modalMessage" 
                :showModal="errorModal.showModal"
                @okClicked="errorModelOkClicked"></error-modal>
    
    <success-modal
            :modalHeading="successModal.modalHeading"
            :elementId="successModal.elementId"
            :modalMessage="successModal.modalMessage"
            :showModal="successModal.showModal"
            @okClicked="successModelOkClicked"></success-modal>

<!--    <assign-sales-rep-to-customers-modal-->
<!--                :heading="customerSalesRep.heading"-->
<!--                :modalId="customerSalesRep.modalId"-->
<!--                :showModal="customerSalesRep.showModal"-->
<!--                @closeClicked="onAssignSalesRepToCustomerCloseClick"-->
<!--                @salesRepSelected="onSalesRepSelectedForCustomer"></assign-sales-rep-to-customers-modal>-->
    
    <assign-salesReps-to-customer-modal
            :heading="customerSalesRep.heading"
            :modalId="customerSalesRep.modalId"
            :showModal="customerSalesRep.showModal"
            :companyId="companyId"
            :companySalesReps="saleReps"
            @onSaveClick="onSalesRepsSelectedForCustomer"
            @onModalCloseClick="onAssignSalesRepToCustomerCloseClick"></assign-salesReps-to-customer-modal>
</div>
